function handbagDisplay(variant, bool) {
  disableField('手提げ袋のご利用', !bool, false, [`【${variant}】の場合は手提げ袋は付きません`]);
  disableField('手提げ袋指定数', !bool, true);
}

function wrapDisplay(variant, bool) {
  disableField('包装', !bool, false, [`【${variant}】の場合は包装は出来ません`]);
  disableField('包装紙', !bool, true);
  disableField('のし紙', !bool, true);
  disableField('のし紙種類', !bool, true);
  disableField('表書き', !bool, true);
  disableField('御名前', !bool, true);
}

function forceWrap(variant, bool) {
  const radioButtonNoWrap = document.querySelector('[name="properties[包装]"][value="しない"]');
  const radioButtonWrap = document.querySelector('[name="properties[包装]"][value="する"]');
  const radioButtonNoWrapValue = radioButtonNoWrap?.closest('.bold_option_value');
  const radioButtonWrapOption = radioButtonWrap?.closest('.bold_option');
  if (radioButtonWrap !== null && radioButtonNoWrap !== null) {
    if (bool) {
      if (radioButtonWrap !== null && radioButtonNoWrap !== null) {
        if (!radioButtonWrap.checked) { radioButtonWrap.click(); }
        if (radioButtonNoWrapValue !== null) {
          radioButtonNoWrapValue.style.display = 'none';
        }
        radioButtonWrapOption?.querySelector('.bold_help_text_hide_nowrap')?.remove();
        radioButtonWrapOption?.append(newSpan([newSmall([`【${variant}】は包装が必要です`])], ['bold_help_text', 'bold_help_text_hide_nowrap']));
      }
    } else {
      if (radioButtonNoWrapValue !== null) {
        radioButtonNoWrapValue.style.display = 'inline-block';
      }
      radioButtonWrapOption?.querySelector('.bold_help_text_hide_nowrap')?.remove();
    }
  }
}

function newSpan(elems, classes) {
  const e = document.createElement('span');
  classes.forEach(cls=>e.classList.add(cls));
  elems.forEach(elem=>e.append(elem));
  return e;
}

function newSmall(elems) {
  const e = document.createElement('small');
  elems.forEach(elem=>e.append(elem));
  return e;
}

function disableField(name, disabled, hideTitle = false, helpText = []) {
  const fieldName = `[name="properties[${name}]"]`;
  const fields = [...document.querySelectorAll(fieldName)];
  fields.forEach(e=>e.disabled=disabled);
  if (fields.length > 0) {
    let fieldSet = fields[0].closest('.bold_option');
    if (fieldSet != null) {
      hideElem(fieldSet, '.bold_option_element', disabled);
      hideElem(fieldSet, '.bold_help_text', disabled);
      if (hideTitle) { hideElem(fieldSet, '.bold_option_title', disabled); }      
      fieldSet.querySelector('span.bold_help_text_disabled')?.remove();
      if (disabled) {
        fieldSet.append(newSpan([newSmall(helpText)],['bold_help_text_disabled', 'bold_help_text']));
      }
    }
  }
}

function hideElem(parent, selector, bool) {
  const propName = 'reservedCssDisplay';
  const elem = parent.querySelector(selector);
  if (elem !== null) {
    const style = window.getComputedStyle(elem);
    const currentDisplay = style.getPropertyValue('display');
    if (bool) {
      if (currentDisplay !== 'none') {
        elem.setAttribute(propName, currentDisplay);
        elem.style.display = 'none';
      }
    } else {
      if (currentDisplay === 'none') {
        const display = elem.getAttribute(propName);
        elem.style.display = display || 'block';
      }
    }
  }
  return elem;
}

function hideWrappingPaper(variant, bool) {
  const wrappingPaper = document.querySelector('input[name="properties[包装紙]"]');
  if (bool) {
    wrappingPaper?.setAttribute('disabled', bool);
  } else {
    wrappingPaper?.removeAttribute('disabled');
  }
  const option = wrappingPaper?.closest('.bold_option.bold_option_swatch');
  if (option) {
    option.style.display = bool?'none':'block';
  }
  const inner = document.querySelector('input[name="properties[のし紙]"][value="包装の中に"]');
  if (bool && inner?.checked) {
    document.querySelector('input[name="properties[のし紙]"][value="包装の外に"]').checked=true;
  }
  if (inner) {
    inner.disabled = bool;
    inner.closest('.bold_option_value').style.display = bool?'none':'inline';
  }
}